export const list4 = {
    title: 'Research Articles about Literature Review.',
    items: [
        {
            type: 'literature',
            title: 'Synthesizing information systems knowledge: A typology of literature reviews',
            author: 'Guy Paré, Marie-Claude Trudel  Mirou Jaana, Spyros Kitsiou ',
            year: 2013
        }]
};